export interface GroupByItem {
  isGroupByHeader: boolean;
}

export class GroupByHelper {
  // static GenerateDataSource(dataSource: any[], groupByKeyName: string, generateGroupHeader: (key: string) => string) {
  //   if (!dataSource || dataSource.length === 0 || groupByKeyName === '') {
  //     return dataSource;
  //   }

  //   var groupByDataSourceMap = new Map<string, any[]>();
  //   dataSource.forEach(item => {
  //     var key = item[groupByKeyName].toString();
  //     if (groupByDataSourceMap.has(key)) {
  //       groupByDataSourceMap!.get(key)!.push(item);
  //     }
  //     else {
  //       groupByDataSourceMap.set(key, [item]);
  //     }
  //   });

  //   var groupedDataSource: any[] = [];
  //   [...groupByDataSourceMap].sort().map(([key, values]) => {
  //     var groupByHeaderData: any = { isGroupByHeader: true };
  //     groupByHeaderData[groupByKeyName] = generateGroupHeader(key);
  //     groupedDataSource.push(groupByHeaderData);
  //     values.forEach(value => groupedDataSource.push({ isGroupByHeader: false, ...value }));
  //   })

  //   return groupedDataSource;
  // }

  // static onPaging(data: any[], pageIndex: number, pageSize: number) {
  //   if (!data || data.length === 0) {
  //     return data;
  //   }

  //   const startIndex = pageIndex * pageSize;
  //   const filter = data.filter((r: GroupByItem) => !r.isGroupByHeader).splice(startIndex, pageSize);
  //   const start = startIndex === 0 ? data[0] : filter[0];
  //   const end = filter[filter.length - 1];
  //   return data.slice(data.indexOf(start), data.indexOf(end) + 1);
  // }

  // static onDataSort(data: any[], sortColumn: string, isAsc: boolean) {
  //   if (!data || data.length === 0) {
  //     return data;
  //   }

  //   var newData: any[] = [];
  //   var sortableData: any[] = [];

  //   data.forEach((item: GroupByItem) => {
  //     if (item.isGroupByHeader) {
  //       newData.push(...GroupByHelper.sortArray(sortableData, sortColumn, isAsc));
  //       sortableData = [];
  //       newData.push(item);
  //     }
  //     else {
  //       sortableData.push(item);
  //     }
  //   });

  //   newData.push(...GroupByHelper.sortArray(sortableData, sortColumn, isAsc));
  //   return newData;
  // }

  static sortArray(array: any[], compareColumn: string, isAsc: boolean) {
    if (!array || array.length === 0) {
      return array;
    }

    return array.slice().sort((a, b) => {
      return GroupByHelper.compare(a[compareColumn], b[compareColumn], isAsc);
    });
  }

  private static compare(a: any, b: any, isAsc: any) {
    if (typeof (a) == 'string' && typeof (b) == 'string') {
      return (a.toLocaleLowerCase() < b.toLocaleLowerCase() ? -1 : 1) * (isAsc ? 1 : -1);
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
}
